/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupMutationResponse, UsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupPathParams } from "../models/UsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroup";

function getUsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupUrl(groupId: UsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupPathParams["groupId"], permission: UsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupPathParams["permission"]) {
  const res = { method: 'POST', url: `/admin/group/${groupId}/permissions/${permission}/allow` as const }  
  return res
}

/**
 * @summary Allow a permission for a group
 * {@link /admin/group/:groupId/permissions/:permission/allow}
 */
export async function usersAuthzAPIAdminPermissionsWriteAllowPermissionToGroup(groupId: UsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupPathParams["groupId"], permission: UsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupPathParams["permission"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getUsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupUrl(groupId, permission).url.toString(), ... requestConfig })  
  return res.data
}